import { useEffect, useState } from "react";
import React from "react";
import { Table, Button, Space, Tag, message } from "antd";
import api from "../../services/api";
import AppLayout from "../../components/AppLayout";
import CategoryDrawer from "./CategoryDrawer";
import {
  DndContext,
  closestCenter
} from "@dnd-kit/core";

import {
  SortableContext,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";

import { arrayMove } from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export default function Categories() {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);

  const load = async () => {
    const res = await api.get("/categories");
    setData(res.data);
  };

  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    try {
      await api.delete(`/categories/${id}`);
      message.success("Category deleted");
      load();
    } catch (err) {
      message.error(
        err.response?.data?.message ||
        "Failed to delete Category"
      );
    }
  };

  const handleDragEnd = async (event) => {

      const { active, over } = event;

      if (!over || active.id === over.id) return;

      const oldIndex = data.findIndex(i => i.id === active.id);
      const newIndex = data.findIndex(i => i.id === over.id);

      const newData = arrayMove(data, oldIndex, newIndex);

      setData(newData);

      const payload = newData.map((item, index) => ({
        id: item.id,
        sort_order: index + 1
      }));

      await api.put("/categories/reorder", payload);

      message.success("Category order updated");

    };


  const columns = [

  {
    title: "",
    dataIndex: "sort",
    key: "drag",
    width: 40,
    align: "center",
    render: () => "☰"
  },

  { title: "Name", dataIndex: "name" },

  {
    title: "Status",
    dataIndex: "status",
    render: (v) =>
      v ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>
  },

  {
    title: "Action",
    render: (_, record) => (
      <Space>
        <Button
          type="link"
          onClick={() => {
            setEdit(record);
            setOpen(true);
          }}
        >
          Edit
        </Button>

        {/* <Button danger type="link" onClick={() => remove(record.id)}>
          Delete
        </Button> */}
      </Space>
    )
  }

];

  const SortableRow = (props) => {

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: props["data-row-key"] });

  const style = {
    ...props.style,
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <tr ref={setNodeRef} style={style} {...attributes} {...props}>
      {React.Children.map(props.children, (child) => {

        if (child?.key === "drag") {
          return React.cloneElement(child, {
            children: (
              <span {...listeners} style={{ cursor: "grab" }}>
                ☰
              </span>
            )
          });
        }

        return child;

      })}
    </tr>
  );

};

  return (
    <div>
      <Button
        type="primary"
        style={{ marginBottom: 16 }}
        onClick={() => {
          setEdit(null);
          setOpen(true);
        }}
      >
        Add Category
      </Button>

      <DndContext
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={data.map(i => i.id)}
            strategy={verticalListSortingStrategy}
          >
            <Table
              rowKey="id"
              columns={columns}
              dataSource={data}
              pagination={false}
              components={{
                body: {
                  row: SortableRow
                }
              }}
            />
          </SortableContext>
        </DndContext>

      <CategoryDrawer
        open={open}
        category={edit}
        onClose={() => setOpen(false)}
        onSuccess={load}
      />
    </div>
  );
}
